import { render, staticRenderFns } from "./TabsWrapper.vue?vue&type=template&id=4e2da8d4&scoped=true"
import script from "./TabsWrapper.vue?vue&type=script&lang=js"
export * from "./TabsWrapper.vue?vue&type=script&lang=js"
import style0 from "./TabsWrapper.vue?vue&type=style&index=0&id=4e2da8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2da8d4",
  null
  
)

export default component.exports